import { InstallationPoint } from '../../../../../../../../../app/entities/InstallationPoint'

export const changeAddress = (
  body: Partial<InstallationPoint> & { orderObjectId: string },
) => {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/work_order_utility/change-address`,
    body,
  }
}

export function doesOrderUpdateAffectScheduledJobs(
  orderObjectId: string,
  newInstallationPoint?: Partial<
    Pick<
      InstallationPoint,
      'city' | 'address' | 'state' | 'zipCode' | 'aptOrSuite'
    >
  >,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderObjectId}/check-impact`,
    body: {
      newInstallationPoint,
    },
  }
}
